import React from 'react';
import {StaticImage} from "gatsby-plugin-image";

function FluorescenceDescription(props) {
    return (
        <div>
            <div className="about-wrapper ptb--120 bg_color--1">
                <div className="container">
                    <div className="row align-items-center text-center text-lg-left">
                        <div className="col-lg-6 col-md-12 col-xl-6 order-0 order-lg-0">
                            <div className="about-inner inner p-2 p-lg-4">
                                <div className="section-title">
                                    <div className="mb-3">
                                        <span className="badge">NEW</span>
                                        <span className="badge">Guided tours</span>
                                    </div>
                                    <h2 className="title mb-3">Mine fluorescence in the Export or Main Tunnel</h2>
                                    <p className="description">Experience the mysterious power of the underground in a completely different way! The walk through the mine is a guided experience in the tunnels, where UV lamps are used to take you on a sensory and visual exploration of the wonderful mineral structures and other surprises underground.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-xl-6 order-1 mt-4 order-lg-1">
                            <div className="thumbnail">
                                <StaticImage
                                    src="../../../assets/images/rudnik/uv-experience-page-1.jpg"
                                    alt="Mine fluorescence at Sitarjevec Mine"
                                    placeholder="blurred"
                                    imgClassName="img-fluid w-100"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-wrapper pb--120">
                <div className="container">
                    <div className="row row--35 align-items-center">
                        <div className="col-lg-6 order-1 order-lg-0">
                            <div className="thumbnail">
                                <StaticImage
                                    src="../../../assets/images/rudnik/uv-experience-page-2.jpg"
                                    alt="Nataša Harisch - UV experience researcher"
                                    placeholder="blurred"
                                    imgClassName="img-fluid w-100"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 order-0 order-lg-1 text-center text-md-left">
                            <div className="about-inner inner">
                                <div className="section-title">
                                    <p className="description">Nataša Harisch, a pharmaceutical technologist and researcher of the mysterious worlds of mycelium, will take you on a UV experience together with a guide. Her work combines science, nature, and creativity. Her love of the forest inspired her to create Gobja potka, a night-time adventure where visitors use UV lights to discover the mysterious world of glowing fungi, forest scents and microscopic networks of life. The project, which combines science and the magic of nature, received an award at the tourism start-up weekend in 2025.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FluorescenceDescription;
